export enum StorageKeys {
  ACTIVE_TAB = "active_tab",
  AUTH_TOKEN = "auth_token",
  THEME_MODE = "theme_mode",
}
